export const FLOW_STUDIO_SQLITE_DB_FILE = 'flowstudio-cache.sqlite';
export const FLOW_STUDIO_SQLITE_WORKER_PROBE_DB_FILE = 'flowstudio-worker-probe.sqlite';

export function locateSqliteWasm(file: string): string {
  if (file === 'sql-wasm-browser.wasm') {
    return '/assets/sql-wasm.wasm';
  }
  return `/assets/${file}`;
}

